import * as React from 'react';
import { DeeplinkBuilderComponent } from './deeplink-builder-component';
import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';

export class DeeplinkBuilder extends React.Component<any, any> {
  public constructor(props) {
    super(props);
  }

  public render() {
    return (
      <Viewport>
        <ViewLarge>
          <div className="uitk-grid all-cell-1-1">
            <div className="uitk-cell all-cell-1-1">
              <div className="uitk-cell">
                <DeeplinkBuilderComponent />
              </div>
            </div>
          </div>
        </ViewLarge>
        <ViewSmall>
          <div className="uitk-grid all-cell-1-1">
            <div className="uitk-cell all-cell-1-1">
              <div className="uitk-cell">
                <DeeplinkBuilderComponent />
              </div>
            </div>
          </div>
        </ViewSmall>
      </Viewport>
    );
  }
}
